<template lang="pug">
//- FIXME question ID should be q_{id}, but review this commit
//- https://bitbucket.org/vinciworksteam/ubercourse/commits/39817302915de303b0b5cff03a9d475123c3bd6c
form.question.dont-unlock.text-lg.w-full.break-inside-avoid(
  :class="{ '-is-submitted': isSubmitted, '-all-correct': isSubmitted && allCorrect }"
  :data-completed="isSubmitted"
  :id="`${screen.id}`"
  ref="el"
  role="region"
  tabindex="-1"
  v-if="isValidData"
) 
  transition-expand
    .question__text.prose-stack.mb-8.fade-in(
      :class="[{ 'mx-auto': screen.center }, screen.styles?.question]"
      v-if="!isSubmitted || !overlay"
    )
      uc-editable.font-bold(
        :edit-path="`${editPath}.question`"
        :k="`${screen.id}.question`"
        :text="screen.question"
      )
      template(v-if="!audioDoc")
        uc-text.italic(
          :k="selectCountMessage"
          :text="selectCountMessage"
          :values="{ selectCount }"
          type="p"
          v-if="selectCount > 1 || forceCountMessage"
        )

  //- question container (includes submit/retry buttons and feedback text. Flex gap for spacing both horiz and vert)
  .flex.flex-col.w-full.gap-16(
    :class="{ 'md_flex-row': !hasImageOptions && !vertical && !overlay }"
    v-if="!audioDoc"
  )
    uc-preload-sfx(name="click1")
    uc-preload-sfx(name="select")
    uc-preload-sfx(name="continue")
    transition-expand
      .flex-1(v-if="!isSubmitted || !overlay")
        //- image options
        fieldset(
          :disabled="isSubmitted && !isEditModeActive"
          uc-dont-read=""
          v-if="hasImageOptions"
        )
          ul.question__options.flex.flex-wrap.justify-center.items-stretch.gap-6.gap-y-6.w-full.cards
            li.question-option.relative.flex.bg-paper.surface.corners.cursor-pointer.shadow-md.fade-in.card(
              :class="[`card--cols-${screen.cols || 3}`]"
              v-for="(option, i) in screen.options"
            )
              input.peer.sr-only(
                :checked="isSelected(i)"
                :disabled="isSubmitted || isWrongAttempt(i) || isEditModeActive"
                :id="getOptionId(i)"
                :key="getOptionId(i)"
                :value="getValueAttr(option)"
                @change="changeHandler"
                :type="displayRadios ? 'radio' : 'checkbox'"
                uc-word-skip=""
              ) 

              label.text-base.flex-1.flex.flex-col.justify-between.corners(
                :class="[!isEditModeActive && 'overflow-hidden', !isWrongAttempt(i) && !isEditModeActive && 'cursor-pointer ripple', { 'opacity-30': (isSubmitted && !isCorrect(option) && (!isRetryAllowed || !hasAttemptsRemaining) && !isEditModeActive) || isWrongAttempt(i) }]"
                :for="getOptionId(i)"
                class="ripple_bg-white/20"
                uc-word-skip=""
              )
                uc-text.sr-only(
                  text="correct selected"
                  v-if="isSubmitted && isSelected(i) && isCorrect(option)"
                )
                uc-text.sr-only(
                  text="incorrect selected"
                  v-else-if="isSubmitted && isSelected(i) && !isCorrect(option)"
                )
                .question-option-img-wrapper 
                  uc-asset.min-w-full.z-1.object-cover.aspect-square.max-h-64(
                    :alt="hasTranslation(`${option.id}.${option[0] ? 0 : 1}.alt`, getImage(option).alt)"
                    :src="getImage(option).img"
                    :title="hasTranslation(`${option.id}.${option[0] ? 0 : 1}.alt`, getImage(option).alt)"
                    data-sfx="select"
                  )

                uc-editable.py-3.px-4.flex-1.dark_text-white(
                  :class="[isEditModeActive ? 'opacity-100' : 'opacity-80', { 'opacity-100 font-semibold text-black dark_text-white pe-2': isSubmitted ? isCorrect(option) : isSelected(i) }]"
                  :edit-path="`${editPath}.options.${i}.${option[0] ? 0 : 1}.text`"
                  :k="`${option.id}.${option[0] ? 0 : 1}.text`"
                  :text="getImage(option).text"
                  v-if="getImage(option).text"
                )

              //- word doc option/image text
              span(
                :uc-word-bold="isCorrect(option) && highlightAnswers ? true : null"
                v-if="wordDoc"
              )
                uc-text(
                  :k="`${option.id}.${option[0] ? 0 : 1}.text`"
                  :text="getImage(option).text"
                  v-if="getImage(option).text"
                )
                | &nbsp;
                uc-text.italic(
                  :text="'[' + hasTranslation(`${option.id}.${option[0] ? 0 : 1}.alt`, getImage(option).alt) + ']'"
                  v-if="getImage(option).alt"
                )

              .fill.transition.pointer-events-none.corners.ring-0(
                :class="{ 'ring-primary-500 ring-4': (isSubmitted && isCorrect(option) && !isEditModeActive && (!isRetryAllowed || !hasAttemptsRemaining)) || (!isSubmitted && isSelected(i)), '-z-1 ring-gray-500 ring-2': isEditModeActive && isCorrect(option) }"
              )
              .fill.transition.pointer-events-none.corners.peer-focus-visible_ring-8
              .feedback-icon.absolute.text-xl.top-0.left-0.text-primary-500.rounded-full.aspect-square.flex.items-center.justify-center.p-1(
                :class="[isCorrect(option) && !isEditModeActive ? 'bg-primary-500 m-[calc(-0.75rem_-_4px)]' : !isEditModeActive && !isCorrect(option) && 'bg-gray-500 -m-3', { 'bg-green-500 m-[calc(-0.75rem_-_4px)]': isEditModeActive && isCorrect(option) }]"
                class=""
                v-if="(isSubmitted && isSelected(i)) || (isCorrect(option) && isEditModeActive)"
              )
                uc-icon.text-white(icon="theme:check" v-if="isCorrect(option)")
                uc-icon.text-white(icon="theme:error" v-else-if="!isEditModeActive")

        //- normal or card options (not images)
        fieldset.flex-1(:disabled="isSubmitted && !isEditModeActive" uc-dont-read="" v-else="")
          ul.question__options.inline-flex.flex-col(
            :class="[cards ? 'gap-4' : 'gap-0']"
          )
            li.fade-in(
              :style="{ order: order[i] }"
              v-for="(option, i) in screen.options"
            )
              label.question-option.flex.items-center.justify-start.transition(
                :class="[{ ripple: !isWrongAttempt(i) && !isEditModeActive }, cards && 'question-option--card', twMerge(cards ? 'bg-white corners dark_bg-gray-900 p-4 shadow-md' : !isEditModeActive && 'border-b-2 border-primary-600', !cards && 'py-2', cards && (isSelected(i) || isWrongAttempt(i)) && 'bg-primary-200 dark_bg-primary-500', cards && isSubmitted && isSelected(i) && !isCorrect(option) && 'saturate-[0.1]', isWrongAttempt(i) && 'saturate-[0.1] border-primary-500/25', !cards && isSubmitted && !isCorrect(option) && (!isRetryAllowed || !hasAttemptsRemaining) && 'border-primary-500/25', isEditModeActive && isCorrect(option) && ' border-2 border-gray-400 rounded-md my-1')]"
              )
                .ripple__wave

                .question-option__background.fill.transition(
                  v-if="!isWrongAttempt(i) && !isEditModeActive"
                )
                input.sr-only.peer(
                  :checked="isSelected(i)"
                  :data-sfx="displayRadios ? 'click1' : 'select'"
                  :disabled="isSubmitted || isWrongAttempt(i) || isEditModeActive"
                  :id="getOptionId(i)"
                  :key="getOptionId(i)"
                  :value="getValueAttr(option)"
                  @change="changeHandler"
                  :type="displayRadios ? 'radio' : 'checkbox'"
                  uc-word-skip=""
                )
                uc-text.sr-only(
                  text="correct selected"
                  v-if="isSubmitted && isSelected(i) && isCorrect(option)"
                )
                uc-text.sr-only(
                  text="incorrect selected"
                  v-else-if="isSubmitted && isSelected(i) && !isCorrect(option)"
                )
                .question-option__checkbox.transition.w-4.aspect-square(
                  :class="[(isSubmitted || isWrongAttempt(i)) ? 'opacity-0' : isEditModeActive && 'opacity-40', displayRadios ? 'rounded-full' : 'rounded-sm', cards ? 'hidden' : 'inline-flex flex-none']"
                )
                  transition-pop(:duration="0.15")
                    .inline-flex.items-center.justify-center(
                      v-if="isSelected(i)"
                    )
                      uc-icon.scale-75(
                        :active="isSelected(i)"
                        icon="mdi:circle"
                        v-if="displayRadios"
                      )
                      uc-icon(
                        :active="isSelected(i)"
                        icon="mdi:check-bold"
                        v-else=""
                      )

                .question-option__text.prose-stack.ps-4.flex-1(
                  :class="isSelected(i) ? 'pe-0' : 'pe-3'"
                  :uc-word-bold="isRetryAllowed || isCorrect(option) && highlightAnswers ? true : null"
                )
                  uc-editable(
                    :class="{ 'opacity-30': (!cards && isSubmitted && !isCorrect(option) && !isEditModeActive && (!isRetryAllowed || !hasAttemptsRemaining)) || isWrongAttempt(i), 'opacity-100 font-semibold text-black dark_text-white': isSubmitted ? isCorrect(option) && (!isRetryAllowed || !hasAttemptsRemaining) : isSelected(i) }"
                    :edit-path="`${editPath}.options.${i}.${option[0] ? 0 : 1}`"
                    :k="option[0] ? `${option.id}.0` : `${option.id}.1`"
                    :text="option[0] || option[1]"
                  )

                .question-option__icon.inline-flex.items-center.justify-center.auto-alpha-1.relative.flex-none(
                  :class="[twMerge(cards ? 'order-first mx-1 bg-primary-100 h-10 w-10 flex-none rounded-full overflow-hidden' : 'ms-auto pl-4 -my-2 me-1 w-12 text-primary-500', cards && isSelected(i) && 'bg-primary-800 text-white', cards && isSubmitted && isCorrect(option) && !isSelected(i) && (!isRetryAllowed || !hasAttemptsRemaining) && 'bg-primary-500', cards && isSubmitted && !isCorrect(option) && !isSelected(i) && !isRetryAllowed && '!opacity-20')]"
                )
                  .text-3xl.inline-flex.items-center(
                    :class="[cards && 'text-white']"
                    v-if="cards ? isSubmitted && isSelected(i) : isSubmitted"
                  )
                    uc-icon(
                      icon="theme:check"
                      v-if="isSelected(i) && isCorrect(option)"
                    )
                    uc-icon(
                      icon="theme:error"
                      v-if="isSelected(i) && !isCorrect(option)"
                    )

                  .heading.text-xl.inline-flex.items-center.justify-center.w-full.tracking-normal(
                    :class="twMerge(isSelected(i) ? '!text-white' : '!text-primary-900', isSubmitted && isCorrect(option) && !isSelected(i) && '!text-white')"
                    v-else-if="cards"
                  )
                    span {{ getCardOptionLabel(i) }}

                //- MARKING ICON (desktop: end of item row)
                transition-pop
                  .question-edit__icon.items-center.-me-4.lg_flex.bg-green-500(
                    v-if="isEditModeActive && isCorrect(option)"
                    :class="{ 'cards-end': cards }"
                  )
                    uc-icon.-top-2.text-white(
                      icon="theme:check"
                    )

        uc-animate.question__submit-wrapper(
          :class="[{ 'hidden': isSubmitted }]"
          animate="time-1"
        )
          .group.mt-8.question__submit-btn.flex.items-center.gap-6(
            :class="[{ 'flex-row-reverse': hasImageOptions, 'flex-wrap gap-2': smallDevice }]"
          )
            uc-preload-sfx(name="yes")
            uc-preload-sfx(name="wrong")
            uc-preload-sfx(name="survey-submit")
            //- submit button
            uc-button.btn.btn-primary.question__submit(
              :class="[{ unlock: screen.survey && !screen.feedback, 'w-full': smallDevice }]"
              :data-sfx="screen.survey ? 'survey-submit' : allCorrect ? 'yes' : 'wrong'"
              :disabled="disableSubmit"
              ref="submit"
              @click="submitHandler"
              text="Submit"
            )

            //- select count message
            p.transition.opacity-0.group-hover_opacity-100.italic.question__submit-hint.duration-500.group-hover_delay-1000(
              :class="[{ 'w-full': smallDevice, 'invisible': selected.length === selectCount }]"
              uc-word-skip=""
              v-if="!isSubmitted"
            )
              uc-text.dark_text-gray-200(
                :k="selectCountMessage"
                :values="{ selectCount }"
                :text="selectCountMessage"
              )

    .question__feedback.flex-1.fade-in(
      ref="feedbackRef" 
      v-if="screen.feedback"
      aria-live="polite"
      aria-atomic="true"
      role="status"
      )
      transition-expand(
        :delay="overlay || isRetryAllowed ? 0 : 0.5"
        :duration="1"
        scroll=""
        v-if="!lightbox"
      )
        .question__feedback-content.outline-2.block(
          v-if="isSubmitted || wordDoc"
        ) 
          //- expose these strings for the translate script
          //- text="Feedback"
          //- text="That’s right!"
          //- text="Not quite."
          uc-text.prose.md_prose-lg.text-primary-700.dark_text-primary-300.font-bold.italic.feedback-heading.mb-4(
            :class="[{ 'mx-auto': screen.center }, screen.styles?.question]"
            :k="wordDoc || screen.survey ? 'Feedback' : allCorrect ? 'That’s right!' : 'Not quite.'"
            :text="wordDoc || screen.survey ? 'Feedback' : allCorrect ? 'That’s right!' : 'Not quite.'"
            type="p"
            uc-dont-read=""
            v-if="!wordDoc && !hideFeedbackTitle"
          )

          //- feedback text
          uc-editable.prose.dark_prose-invert(
            :class="[{ 'mx-auto': screen.center }, screen.styles?.text]"
            :edit-path="feedbackEditPath"
            :k="feedback?.path && `${screen.id}.${feedback.path}`"
            :text="feedback?.text"
            uc-dont-read=""
            uc-word-skip=""
          )
          slot

      //- retry button (under feedback text)
      .group.mt-8.question__retry-btn.flex.items-center.gap-6(
        :class="{ 'flex-row-reverse': hasImageOptions, 'flex-wrap gap-2': smallDevice }"
        v-if="isSubmitted && isRetryAllowed && hasAttemptsRemaining && !allCorrect"
      )
        uc-button.btn.btn-primary.question__retry(
          :class="[{ 'w-full': smallDevice }]"
          @click="retryQuestion"
          icon="mdi:refresh"
          text="Try again"
          data-sfx="continue"
        )

      //- show feedback button (for lightbox feedback)
      .group.mt-8.question__retry-btn.flex.items-center.gap-6(
        :class="{ 'flex-row-reverse': hasImageOptions, 'flex-wrap gap-2': smallDevice }"
        v-if="lightbox && isSubmitted"
      )
        uc-button.btn.btn-primary.primary-green.border-primary-700.question__retry(
          :class="[{ 'w-full': smallDevice }]"
          @click="showFeedback"
          text="Show feedback"
          data-sfx="continue"
        )

  //- render all conditional feedback (if any) for word docs and audio docs
  div(v-for="[k, v] in allConditionalFeedback" v-if="!lightbox && (wordDoc || audioDoc)")
    audio-marker(:name="`${screen.id}-${k}`" v-if="k === 'feedback'")
    audio-marker(:name="`${screen.id}-feedback-${k}`" v-else="")
    p(uc-dont-read="" v-if="!audioDoc")
      uc-text.font-bold(text="Feedback")

      span &nbsp;

      //- expose these strings for the translate script
      //- text="(correct)"
      //- text="(incorrect)"
      uc-text.font-bold(:text="`(${k})`" type="span" v-if="k !== 'feedback'") 

    uc-text(
      :k="`${screen.id}.feedback`"
      :text="v"
      type="p"
      v-if="k === 'feedback'"
    )
    uc-text(:k="`${screen.id}.feedback.${k}`" :text="v" type="p" v-else="")

</template>

<script lang="ts">
export default {
  inheritAttrs: false
};
</script>

<script setup lang="ts">
import {
  nextTick,
  ref,
  computed,
  unref,
  inject,
  reactive,
  watch,
  watchEffect,
  onMounted,
  toRef,
  type Ref
} from 'vue';
import { set, setCompleted } from '../lib/SCORM';
import gsap from 'gsap';
import useSuspend from '../lib/useSuspend';
import { play, stop } from '../lib/audio';
import twMerge from '../lib/mergeStyles';
import useQuizzes from '../stores/useQuizzes';
import bugAlert from '../lib/bugAlert';
import { useCompletables } from '../stores/useLockables';
import openLightbox from '../lib/openLightbox';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import useTranslations from '../stores/useTranslations';
import { saveInsightsData } from '../lib/insightsData';
import useScreenAudio from '../lib/useScreenAudio';
import questionSchema from '../lib/screen-schemas/screen-question.schema';

type Option = ScreenQuestion['options'][0];

let wrongAttemptedOptions: string[] = reactive([]);

const wordDoc = inject('wordDoc') as boolean;
const audioDoc = inject('audioDoc') as boolean;
const highlightAnswers = inject('highlightAnswers') as boolean;
const ABC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const props = defineProps<{ editPath?: string; screen: ScreenQuestion }>();
const submit = ref<HTMLElement>();
const suspend = useSuspend();
const { translations } = useTranslations();
const sectionId = inject('sectionId') as string;
const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
const { playSlot } = useScreenAudio(toRef(props, 'screen'), questionSchema);
const attemptCounter = ref(0);
const submittedState = ref(false);
const breakpoints = useBreakpoints(breakpointsTailwind);
const smallDevice = breakpoints.smallerOrEqual('sm');
const mediumDevice = breakpoints.greaterOrEqual('md');
const largeDevice = breakpoints.greaterOrEqual('lg');
const el = ref<HTMLElement>();

const pageId = inject('pageId') as object;

const overlay = computed(() => props.screen['feedback-layout'] === 'replace');
const vertical = computed(() => props.screen['feedback-layout'] === 'bottom');
const lightbox = computed(() => props.screen['feedback-layout'] === 'lightbox');
const cards = computed(() => props.screen['option-style'] === 'card');
const feedback = computed(() => getFeedbackString(props.screen.feedback));
const hasImageOptions = computed(
  () =>
    typeof (props.screen.options[0][0] || props.screen.options[0][1]) !==
    'string'
);

const getCardOptionLabel = function (i: number) {
  if (typeof i !== 'number') return '';
  const letterLabel = ABC[i];
  if (!suspend.locale) return letterLabel;
  // Latin script language codes
  const latinLocales = [
    'en',
    'es',
    'fr',
    'de',
    'it',
    'pt',
    'nl',
    'pl',
    'ro',
    'cs',
    'sk',
    'sl',
    'hr',
    'hu',
    'da',
    'sv',
    'no',
    'fi',
    'et',
    'lv',
    'lt',
    'tr',
    'id',
    'ms',
    'vi',
    'tl',
    'sw',
    'af',
    'sq'
  ];
  const isLatin = latinLocales.some(prefix =>
    suspend.locale.toLowerCase().startsWith(prefix)
  );

  return isLatin ? letterLabel : i + 1;
};

const feedbackEditPath = computed(() => {
  if (!props.editPath) return null;

  return feedback.value?.path
    ? `${props.editPath}.${feedback.value.path}`
    : `${props.editPath}.feedback`;
});

useCompletables(props.screen.id);

const hideFeedbackTitle = computed(() => {
  return props.screen['feedback-no-title'] ?? false;
});

/*
 * Validate we have feedback text if we are using attempts
 */
const isValidData = computed(() => {
  // check that we have specified feedback text if we are using attempts
  if (isRetryAllowed.value && !props.screen.feedback) {
    console.log(
      props.screen.id,
      'isValidData',
      isRetryAllowed.value,
      feedback.value
    );
    bugAlert(
      `Screen #${props.screen.id}\n\nYou have specifed to use attempts but there is no feedback. Feedback is required.\n\nattempts: ${props.screen.attempts}`
    );

    if (import.meta.env.DEV) return false;
  }

  if (isRetryAllowed.value && props.screen['feedback-layout'] === 'replace') {
    bugAlert(
      `Screen #${props.screen.id}\n\nYou have used attempts: ${props.screen.attempts} with feedback-layout: replace, which cannot be used together. Please remove one.`
    );

    if (import.meta.env.DEV) return false;
  }

  if (props.screen['select-count'] && props.screen['hide-correct-count']) {
    bugAlert(
      `Screen #${props.screen.id}\n\nYou have used both select-count and hide-correct-count, which cannot be used together. Please remove one.`
    );

    if (import.meta.env.DEV) return false;
  }

  if (props.screen['select-count'] && props.screen['survey'] !== 'multi') {
    bugAlert(
      `Screen #${props.screen.id}\n\nYou have specified a manual select-count: ${props.screen['select-count']} which can only be used with survey: multi.`
    );

    if (import.meta.env.DEV) return false;
  }

  if (
    props.screen['feedback-layout'] === 'lightbox' &&
    el.value?.closest('.lightbox')
  ) {
    bugAlert(
      `Screen #${props.screen.id}\n\nYou have used feedback-layout: lighbox inside a lightbox screen. Pleas use another feedback-layout type.`
    );

    if (import.meta.env.DEV) return false;
  }

  return true;
});

// use flex order to shuffle options
const order = computed(() => {
  const count = props.screen.options.length;

  return props.screen['shuffle-options']
    ? [...Array(count)].map(() => Math.floor(Math.random() * 10000))
    : Array(count).fill(0);
});

const { register } = useQuizzes();

register(props.screen, pageId);

const selected = computed(() => {
  return suspend.questionOptions[props.screen.id] || [];
});

const isSubmitted = computed(() => {
  if (isRetryAllowed.value) {
    return submittedState.value;
  } else {
    return Boolean(suspend.completed[props.screen.id]);
  }
});

// counts how many options should be selected
const selectCount = computed(() => {
  const manualCount = props.screen['select-count'];
  const calculatedCount = props.screen.options.reduce(
    (a, c) => (c[1] ? a + 1 : a),
    0
  );

  return props.screen.survey === 'single'
    ? 1
    : props.screen.survey === 'multi' &&
        manualCount &&
        manualCount <= calculatedCount
      ? manualCount
      : calculatedCount;
});

const displayRadios = computed(
  () => props.screen.survey !== 'multi' && selectCount.value === 1
);

const disableSubmit = computed(() => {
  if (isEditModeActive.value) return false;

  return isSubmitted.value
    ? true
    : props.screen['hide-correct-count']
      ? selected.value.length === 0
      : props.screen.survey === 'multi' &&
          props.screen['select-count'] === 1 &&
          selected.value.length === 0
        ? true
        : props.screen.survey === 'multi' &&
            selectCount.value === props.screen.options.length
          ? false
          : props.screen.survey === 'single'
            ? selected.value.length === 0
            : selected.value.length !== selectCount.value;
});

const englishNumbers = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten'
];

const selectCountMessage = computed(() =>
  // expose these strings for the translate script
  // text="Please select all options that apply."
  // text="Please select ${selectCount} options."
  // text="Please select an option."
  props.screen['hide-correct-count'] && selectCount.value > 1
    ? 'Please select all options that apply.'
    : forceCountMessage.value && selectCount.value === 1
      ? 'Please select an option.'
      : (selectCount.value > 1 && props.screen.survey !== 'multi') ||
          (props.screen.survey === 'multi' && props.screen['select-count'])
        ? suspend.locale === 'en-GB'
          ? `Please select ${englishNumbers[selectCount.value]} options.`
          : 'Please select ${selectCount} options.'
        : props.screen.survey !== 'multi' &&
            selected.value.length !== selectCount.value
          ? 'Please select an option.'
          : ''
);

const forceCountMessage = computed(() => {
  return props.screen['force-instructions'];
});

const allCorrect = computed(() => {
  let result = true;
  props.screen.options.forEach((o, i) => {
    const checked = isSelected(i);
    if ((o[0] && checked) || (o[1] && !checked)) {
      result = false;
    }
  });
  return result;
});

// 0 is unlimted attempts 2+ is limited (1 is the same as normal)
const isRetryAllowed = computed(() => {
  const maxAttempts = props.screen?.attempts ?? -1;
  return Boolean(maxAttempts === 0 || maxAttempts > 1);
});

const hasAttemptsRemaining = computed(() => {
  const maxAttempts = props.screen?.attempts ?? -1;

  if (allCorrect.value) {
    return false;
  } else if (maxAttempts === 0 || maxAttempts === -1) {
    return !allCorrect.value;
  } else {
    return attemptCounter.value < maxAttempts;
  }
});

const isFinalAttempt = computed(() => {
  const maxAttempts = props.screen?.attempts ?? -1;
  return Boolean(attemptCounter.value === maxAttempts - 1);
});

function initNextButtonCheck() {
  // Try and see if there is an issue with the next button not showing. If there is try and set auto-alpha-1 on the next button and write a to console
  try {
    const section = el.value?.closest('.section') as HTMLElement;
    const nextButton = section?.querySelector(
      '.screen-next-button'
    ) as HTMLElement;
    const nearestScreen = section?.closest('.screen') as HTMLElement;

    //await nextTick();

    // check if next button has css transition-delay and remove it in case it compflicts with the uc-screen mixin classes
    if (nextButton && nextButton.style.transitionDelay) {
      nextButton.style.transitionDelay = '';
    }

    if (nextButton && nextButton.classList.contains('auto-alpha-1')) {
      return;
    }

    if (nextButton && suspend.completed[sectionId]) {
      nextButton.classList.add('auto-alpha-1');
      console.warn('Debug: next button set to auto-alpha-1: ', sectionId);
      return;
    }

    if (nextButton && suspend.completed[props.screen.id]) {
      nextButton.classList.add('auto-alpha-1');
      console.warn('Debug: next button set to auto-alpha-1: ', props.screen.id);
      return;
    }

    if (
      (!suspend.completed[sectionId] || !suspend.completed[props.screen.id]) &&
      suspend.correctQuestions[props.screen.id]
    ) {
      console.warn(
        'Debug: section or screen are not complete but correctQuestions is set for screen: ',
        props.screen.id
      );
    }
  } catch (error) {
    console.error('Error initializing next button check: ', error);
  }
}

onMounted(() => {
  // Add some code to ensure that if the question is completed set the alpha on the next button to 1
  initNextButtonCheck();
});

function getValueAttr(option: Option) {
  // if (hasImageOptions.value) {
  //   debugger;
  // }
  if (import.meta.env.DEV) {
    return isCorrect(option) ? 1 : 0;
  }

  return JSON.stringify(option[0] || option[1]);
}

function changeHandler(e: Event & { target: HTMLInputElement }) {
  let sel = unref(selected);
  const limit = !props.screen['hide-correct-count'] || selectCount.value === 1;

  if (e.target.checked) {
    sel.unshift(e.target.id);
    if (limit) sel.splice(selectCount.value);
  } else {
    sel.splice(sel.indexOf(e.target.id), 1);
  }

  set(`questionOptions.${props.screen.id}`, sel);
}

// used by the question retry button, only resets submittedState and questionOptions
function retryQuestion() {
  stop();
  setRetryState();
  el.value?.focus();
}

function setRetryState() {
  submittedState.value = false;
  delete suspend.questionOptions[props.screen.id];
}

function showFeedback() {
  if (lightbox.value) {
    openLightbox(feedback.value.text);
  }
}

// used by KS and results retry button, resets submittedState, questionOptions, attemptCounter, and wrongAttemptedOptions
function resetQuestion() {
  attemptCounter.value = 0;
  wrongAttemptedOptions = [];

  setRetryState();
}

// the KS and results screen has a reset screen button, so listen for the resetting of the screen's completion
watch(
  () => suspend.completed[props.screen.id],
  (newVal, oldVal) => {
    if (oldVal && !newVal && isRetryAllowed.value) {
      resetQuestion();
    }
  }
);

function delayNextButton(delay) {
  const section = el.value?.closest('.section') as HTMLElement;
  const nextButton = section?.querySelector(
    '.screen-next-button'
  ) as HTMLElement;

  if (nextButton)
    nextButton.style.transitionDelay = suspend.reducedMotion
      ? '0s'
      : `${delay}s`;
}

async function submitHandler(e: Event) {
  stop();
  attemptCounter.value++;

  submittedState.value = true;

  updateWrongAttempts();

  const { id } = props.screen;
  const isComplete = isRetryAllowed.value
    ? allCorrect.value || !hasAttemptsRemaining.value
    : true;

  // console.log(isRetryAllowed.value, attemptCounter.value, maxAttempts, hasAttemptsRemaining.value, isComplete)

  // we need to apply the delay before completion
  //delayNextButton(feedback.value ? 2 : 1);
  delayNextButton(feedback.value ? 1 : 0.5);

  if (isComplete) setCompleted(id);

  await nextTick();

  set(`questionOptions.${id}`, selected.value);
  set(`correctQuestions.${id}`, allCorrect.value);

  if (lightbox.value) {
    openLightbox(feedback.value.text);
  } else {
    playFeedbackAudio();
  }

  await new Promise(r => gsap.delayedCall(props.screen.feedback ? 0.5 : 0, r));

  if (isComplete) {
    setCompleted(sectionId);
    saveInsightsData(props.screen, {
      correct: allCorrect.value
    });
  }
}

/**
 * Returns an object `{ text, path }`, computed from the given feedback prop and the status of the user's selection.
 *
 * The `text` is the relevant feedback string to display. The `path` is where in the YAML the string was found, for the purpose of finding its translation key, e.g., `feeback` or `feedback.correct`.
 *
 * @param f The feedback string, or object when conditional
 */
function getFeedbackString(f: ScreenGridQuestion['feedback']): {
  text: string | object;
  path: string;
  audio: string;
} | null {
  // no feedback
  if (!f) return null;

  // single feedback text
  if (typeof f === 'string')
    return { text: f, path: 'feedback', audio: 'feedback' };

  // correct
  if (f.correct && allCorrect.value)
    return {
      text: f.correct,
      path: 'feedback.correct',
      audio: 'feedback-correct'
    };

  // option-specific
  let i = props.screen.options.length;

  while (i--) {
    if (f[i + 1] && isSelected(i)) {
      return {
        text: f[i + 1],
        path: 'feedback.' + (i + 1),
        audio: 'feedback-' + (i + 1)
      };
    }
  }

  // retry-final
  if (f['retry-final'] && !allCorrect.value && isFinalAttempt.value)
    return {
      text: f['retry-final'],
      path: 'feedback.retry-final',
      audio: 'feedback-retry-final'
    };

  // retry
  if (f['retry'] && !allCorrect.value && hasAttemptsRemaining.value)
    return {
      text: f['retry'],
      path: 'feedback.retry',
      audio: 'feedback-retry'
    };

  // incorrect
  if (f.incorrect && !allCorrect.value)
    return {
      text: f.incorrect,
      path: 'feedback.incorrect',
      audio: 'feedback-incorrect'
    };

  return null;
}

const allConditionalFeedback = computed<[string, string][]>(() => {
  if (typeof props.screen.feedback === 'string')
    return [['feedback', props.screen.feedback]];

  return (
    Object.entries(props.screen.feedback || {})

      // filter for valid feedback
      .filter(([k, v]) => {
        if (typeof v === 'string' && v.trim()) return true;

        bugAlert(
          `Invalid feedback for condition "${k}" in question #${props.screen.id}`
        );
      })
  );
});

function playFeedbackAudio() {
  // Tier 1: explicit prop-level feedback-audio / feedback-speech URL
  const propF =
    props.screen['feedback-audio'] || props.screen['feedback-speech'];
  const propFs = getFeedbackString(propF);
  if (propFs?.text) {
    play(propFs.text as string);
    return;
  }

  // Tier 2/3: schema-based — resolveSlot handles S3 (getAudioURL) or JiT
  const slotName =
    getFeedbackString(props.screen.feedback)?.audio ?? 'feedback';
  playSlot(slotName); // fire and forget — audio plays async in background
}

function getOptionId(i: number) {
  return `${props.screen.id}_o${i}`;
}

function getImage(option: Option): QuestionOptionImage {
  const content = option[0] || option[1];
  if (typeof content === 'string') return { text: content };
  return content;
}

function isCorrect(option: Option) {
  return Object.keys(option)[0] === '1';
}

function isSelected(i: number) {
  return selected.value.includes(getOptionId(i));
}

function isWrongAttempt(i: number) {
  return isRetryAllowed.value && wrongAttemptedOptions.includes(getOptionId(i));
}

function updateWrongAttempts() {
  props.screen.options.forEach((option, index) => {
    const checked = isSelected(index);
    if (option[0] && checked) {
      wrongAttemptedOptions.push(getOptionId(index));
    }
  });
}

function hasTranslation(key: string | number, fallback: string | number = key) {
  // get the translation if it exists
  let maybeTranslated =
    translations?.[suspend.locale]?.[key] ||
    translations?.[suspend.locale]?.[fallback];
  return maybeTranslated || fallback || key;
}

watchEffect(() => {
  props.screen.options.forEach((option, i) => {
    const content = option[0] || option[1];
    if (typeof content !== 'string' && content.img && !content.alt) {
      bugAlert(
        `Missing alt text for image option ${i + 1} in question #${
          props.screen.id
        }`
      );
    }
  });
});
</script>

<style scoped>
.question-option {
  min-width: 20ch;
  transition: 0.2s;
}

.question-option__checkbox {
  --auto-alpha-dur-0: 100ms;
  --auto-alpha-dur-1: 150ms;

  @apply border-primary-700/70 text-primary-700 peer-focus-visible_ring-4 dark_border-primary-600/70 dark_text-primary-500 m-1 h-4 w-4 items-center justify-center border-[1.5px] text-sm;
  transition: 0.2s;
}

fieldset:not(:disabled) li:hover .question-option__background.fill {
  @apply bg-primary-500/10;
}

.question-option .ripple__wave {
  @apply bg-primary-500/10;
}

.question-option.card {
  max-width: calc(50% - 2rem);
}

.question-edit__icon {
  @apply text-primary-500 aspect-square h-8 w-8 justify-center rounded-full p-1 text-xl;
}

.question-edit__icon.cards-end {
  @apply -me-8;
}
</style>
